import { render, staticRenderFns } from "./ClassProgressTab.vue?vue&type=template&id=4fc6c04a&scoped=true"
import script from "./ClassProgressTab.vue?vue&type=script&lang=js"
export * from "./ClassProgressTab.vue?vue&type=script&lang=js"
import style0 from "./ClassProgressTab.vue?vue&type=style&index=0&id=4fc6c04a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc6c04a",
  null
  
)

export default component.exports